import React, { Component, Fragment } from "react";
import { Row } from "reactstrap";

import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import Breadcrumb from "../../../containers/navs/Breadcrumb";
import MapSearchContainer from "../../../containers/pages/map-search";
class MapSearchView extends Component {
  render() {
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb heading="menu.map-search" match={this.props.match} />
            <Separator className="mb-5" />
          </Colxx>
        </Row>

        <MapSearchContainer />
      </Fragment>
    );
  }
}

export default MapSearchView;
